/**
 * Default date-of-birth helper.
 *
 * Most travellers are adults, so the DOB field is pre-filled with the same
 * calendar date 18 years ago. This saves users from scrolling the native date
 * picker back ~18 years for the common case while still letting them change it.
 */

/** `YYYY-MM-DD` for the same calendar date 18 years before `today` (local time). */
export const eighteenYearsAgoISO = (today: Date = new Date()): string => {
    const d = new Date(today.getFullYear() - 18, today.getMonth(), today.getDate());
    const yyyy = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${yyyy}-${mm}-${dd}`;
};
